module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$mq.resize && _vm.$mq.above('500px')) ? _c('div', {
    staticClass: "has-gradient-background"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section flex"
  }, [_c('p', {
    staticClass: "is-white subtitle no-margin-bottom is-6 m-l-auto"
  }, [_vm._v("Home "), _c('icon', {
    attrs: {
      "scale": "0.8",
      "name": "chevron-right"
    }
  }), _vm._v(" " + _vm._s(_vm.routeName) + " "), (_vm.subRoute) ? _c('span', [_c('icon', {
    attrs: {
      "scale": "0.8",
      "name": "chevron-right"
    }
  }), _vm._v(" " + _vm._s(_vm.subRoute))], 1) : _vm._e()], 1)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17dfdf9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/breadcrumb.vue
// module id = 1133
// module chunks = 1